import { createFileRoute } from '@tanstack/react-router';
import { RelatorioEstoque } from '@/features/relatorio/page/estoque/RelatorioEstoque';

export const Route = createFileRoute('/a/relatorio/estoque/')({
    component: RelatorioEstoque,
});
